module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Online Sessions")])], 1), _vm._v(" "), _c('div', {
    staticClass: "online",
    slot: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.onlineConnection
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.member
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "account-photo",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.account.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "20",
      "label": " "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(!scope.row.safe_mode) ? _c('el-tooltip', {
          staticClass: "unsafe-icon",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.unsafeMode,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle warn"
        })]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tunnel_code",
      "label": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.wetty_ip ? scope.row.wetty_ip : scope.row.peer_ip) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "width": "80px",
            "white-space": "normal"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("moment")(scope.row.create_time * 1000, 'YYYY-MM-DD HH:mm:ss')) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(_vm.resourceType === 'ecs' && scope.row.agentVersion < '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("Monitor")])], 1) : _vm._e(), _vm._v(" "), (_vm.resourceType === 'ecs' && scope.row.agentVersion >= '3.0.0') ? _c('el-button', {
          attrs: {
            "disabled": !(scope.row.way == 'terminal' || scope.row.way == 'wetty' || (scope.row.way == 'rdp' && scope.row.showRdp)),
            "type": "text",
            "target": "_blank"
          }
        }, [(scope.row.way === 'terminal' || scope.row.way === 'wetty') ? _c('span', {
          on: {
            "click": function($event) {
              _vm.createShadow(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("assistance")])], 1) : _vm._e(), _vm._v(" "), ((scope.row.way === 'rdp' && scope.row.showRdp)) ? _c('span', {
          on: {
            "click": function($event) {
              _vm.onLinkhref(scope.row.linkHref)
            }
          }
        }, [_c('translate', [_vm._v("monitor")])], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.cutOnline(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Disconnect")])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1f65e2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/workgroup-online-connection.vue
// module id = 612
// module chunks = 4 5 6